import { Navigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'

export default function RequireSuperAdmin({ children }: { children: React.ReactNode }) {
  const { user } = useAuth()

  if (!user?.is_super_admin) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
